import styled from 'styled-components';
import {
  ScrollView as BaseScrollView,
  Text as BaseText,
} from '@vizir-banking/banking-app-core/dist/layout';
import {useTheme} from '@vizir-banking/banking-app-core/dist/styles/style-functions';

export const ScrollView = styled(BaseScrollView)`
  height: 1px;
  flex-grow: 1;
  margin-bottom: 10px;
  padding: 0 10px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${useTheme(({colors}) => colors.scrollbarBackground)};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${useTheme(({colors}) => colors.primary)};
    border-radius: 10px;
  }
`;

export const Text = styled(BaseText)`
  font-size: 16px;
  text-align: justify;
  color: ${useTheme(({colors}) => colors.title.primary)};
`;
